// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'oil-tower';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M1.563 16.969h14.874M9 3.156V1.031m5.313 15.938L9.614 5.69a.665.665 0 0 0-1.228 0L3.687 16.969m8.501-8.5H5.811m1.169.599 5.562 3.65m-1.522-3.65-5.562 3.65m0 .001 8.854 4.25m-1.77-4.25-8.854 4.25M6.875 3.156A1.645 1.645 0 0 0 4.75 2.094m6.375 1.062a1.644 1.644 0 0 1 2.125-1.062'
  />
);

export const viewBox = '0 0 18 18';
